export default __webpack_public_path__ + "static/media/play_passive.974d53ca.svg";